module.exports = "<game-navbar></game-navbar>\n<header>\n  <h1>Stuff!</h1>\n</header>\n<main>\n  <router-outlet></router-outlet>\n</main>\n<game-debug-scorecard></game-debug-scorecard>\n<footer>\n  Other stuff...\n</footer>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/HeinousTugboat/Projects/survivalism/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main